import { getLocale } from "../runtime";

const da_userdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Udforsk forskellige brugergrupper på Glimja`
};

const en_userdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Explore different user groups at Glimja`
};

const es_userdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Explora diferentes grupos de usuarios en Glimja`
};

const fi_userdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tutustu erilaisiin käyttäjäryhmiin Glimjalla`
};

const nb_userdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Utforsk ulike brukergrupper på Glimja`
};

const sv_userdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Utforska olika användargrupper på Glimja`
};

const userdescription = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_userdescription(inputs)
	if (locale === "en") return en_userdescription(inputs)
	if (locale === "es") return es_userdescription(inputs)
	if (locale === "fi") return fi_userdescription(inputs)
	if (locale === "nb") return nb_userdescription(inputs)
	if (locale === "sv") return sv_userdescription(inputs)
	return "userDescription";
};

export { userdescription as "userDescription" };